import { Map } from 'immutable';

import * as CrosstabConstants from './constants';
import * as D from './deps';

const INITIAL_STATE = Map({
  [CrosstabConstants.CrossTabStateKeys.XTAB_MY_TAB_ID]: null,
  [CrosstabConstants.CrossTabStateKeys.XTAB_CURRENTLY_PLAYING_TAB_ID]: null,
});

// APPLICATION REDUCER
export default D.createReducer(INITIAL_STATE, {
  [CrosstabConstants.CrossTabActions.SET_XTAB_MY_TAB_ID]: setXtabMyTabId,
  [CrosstabConstants.CrossTabActions.SET_XTAB_CURRENTLY_PLAYING_TAB_ID]:
    setXtabCurrentlyPlayingTabId,
});

// CASE FUNCTIONS

function setXtabMyTabId(state, action) {
  return state.set(CrosstabConstants.CrossTabStateKeys.XTAB_MY_TAB_ID, action.data.tabId);
}

function setXtabCurrentlyPlayingTabId(state, action) {
  return state.set(
    CrosstabConstants.CrossTabStateKeys.XTAB_CURRENTLY_PLAYING_TAB_ID,
    action.data.tabId,
  );
}
